import { useQuery, keepPreviousData } from "@tanstack/react-query";

import { VirtualSportQueryKeys } from "./virtualSportQueryKeys";
import {
  getVirtualBasketballRound,
  getVirtualRound,
} from "@/api/virtualSport";
import { SPORT_CATEGORY } from "@/utils/sports";

// One VFL week's results (İY / MS).
export const useVirtualResults = (leagueId: number, round: number) =>
  useQuery({
    queryKey: [
      VirtualSportQueryKeys.Results,
      SPORT_CATEGORY.VirtualFootball,
      leagueId,
      round,
    ],
    queryFn: () => getVirtualRound(leagueId, round),
    enabled: Boolean(leagueId) && round > 0,
    refetchInterval: 30_000,
    placeholderData: keepPreviousData,
  });

// One VBL matchday's results (quarter scores + final). Separate hook: the match
// shape differs from football's (periods instead of HT score).
export const useVirtualBasketballResults = (leagueId: number, round: number) =>
  useQuery({
    queryKey: [
      VirtualSportQueryKeys.Results,
      SPORT_CATEGORY.VirtualBasketball,
      leagueId,
      round,
    ],
    queryFn: () => getVirtualBasketballRound(leagueId, round),
    enabled: Boolean(leagueId) && round > 0,
    refetchInterval: 30_000,
    placeholderData: keepPreviousData,
  });
